import * as React from "react";
import {
  Button,
  ErrorNotification,
  Margin,
  P,
  TextLink,
} from "@ovotech/element";

export const LeadDeletedPageContent = () => (
  <>
    <ErrorNotification
      id="lead-deleted-error"
      title="It’s been a while"
      style={{ marginBottom: "4rem" }}
    >
      <P>
        The link has expired and we can’t confirm your email address. In order
        to continue, please submit the new application form. If you have any
        questions, give us a call on{" "}
        <TextLink href="tel:03303035059">0330 303 5059</TextLink> or email us at{" "}
        <TextLink href="mailto:electricvehicles@ovoenergy.com">
          electricvehicles@ovoenergy.com
        </TextLink>
      </P>
    </ErrorNotification>

    <Margin top={8} />
    <Button data-testid="retry-button">
      Start the new application process
    </Button>
  </>
);
